import BaseModel from '../base';

import constants from './constants';
import glossary from './glossary';

export default class Expertise extends BaseModel {
  constructor(expertise = {}, url) {
    super(expertise, url);

    this.estimate_id = expertise.estimate_id;
    this.estimate_list = expertise.estimate_list || [];
    this.estimates = expertise.estimates || [];
    this.expert_id = expertise.expert_id;
    this.expert_name = expertise.expert_name;
    this.journal_id = expertise.journal_id;
    this.question_id = expertise.question_id;
  }

  get totalEstimateScore() {
    return this.estimate_list.reduce((acc, { score }) => acc + (score || 0), 0);
  }

  static get constants() {
    return constants;
  }

  static get glossary() {
    return glossary;
  }
}
